import { createTheme } from '@mui/material/styles';

const BridgMuiTheme = createTheme({
  palette: {
    primary: {
      main: '#105eeb', // $blue-two
    },
  },
  typography: {
    allVariants: {
      fontFamily: 'Proxima Nova'
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontFamily: 'Proxima Nova Semibold',
          fontSize: '0.75rem',
          minWidth: '95px',
          textTransform: 'none',
          variants: [{
            props: { variant: 'outlined' },
            style: {
              backgroundColor: 'white',
            },
          }, {
            props: { size: 'small' },
            style: {
              padding: '7px 12px',
              lineHeight: '14px',
            },
          }, {
            props: { size: 'medium' },
            style: {
              padding: '8px 24px',
              fontSize: '0.875rem'
            },
          }, {
            props: { size: 'large' },
            style: {
              padding: '8px 24px',
              fontSize: '0.875rem'
            },
          }],
        },
      },
    },
    MuiChip: {
      defaultProps: { variant: 'outlined', size: 'small' },
      styleOverrides: {
        root: {
          fontSize: '11px',
          paddingBottom: '2px',
          paddingTop: '3px',
          letterSpacing: '1px',
          marginTop: '-2px',
          height: '20px',
          variants: [{
            props: { variant: 'outlined' },
            style: {
              borderRadius: '3px',
              fontFamily: 'Proxima Nova Semibold', // core.$font-family-semibold;
              border: '1px solid #d5e5fc', // core.$sky-four;
            },
          }, {
            props: { variant: 'outlined', color: 'success' },
            style: {
              color: '#1f926e', // core.$sea-green;
              borderColor: '#1f926e', // core.$sea-green;
            },
          }, {
            props: { variant: 'outlined', color: 'default' },
            style: {
              color: '#a6b9dd', // core.$powder-blue;
              borderColor: '#a6b9dd', // core.$powder-blue;
            },
          }, {
            props: { variant: 'outlined', color: 'primary' },
            style: {
              color: '#3077f1', // core.$blue-one;
              borderColor: '#3077f1', // core.$blue-one;
            },
          }, {
            props: { variant: 'outlined', color: 'error' },
            style: {
              color: '#c63841', // core.$persian-red;
              borderColor: '#c63841', // core.$persian-red;
            },
          }, {
            props: { variant: 'outlined', color: 'warning' },
            style: {
              color: '#ffc856', // core.$mustard;
              borderColor: '#ffc856', // core.$mustard;
            },
          }, {
            props: { variant: 'outlined', color: 'info' },
            style: {
              color: '#119da4', // core.$data-blue;
              borderColor: '#119da4', // core.$data-blue;
            },
          }],
        },
      },
    },
  },
});

export default BridgMuiTheme;
